import React from 'react';
import { useNavigate } from 'react-router-dom';

import Sidebar from '../components/Sidebar';

const DashboardPage: React.FC = () => {
  const navigate = useNavigate();
  const userJson = localStorage.getItem('auth:user');
  const user = userJson ? (JSON.parse(userJson) as { email: string }) : null;

  const handleLogout = () => {
    localStorage.removeItem('auth:user');
    void navigate('/', { replace: true });
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f5f7fb' }}>
      <Sidebar />
      <main style={{ flex: 1, padding: '2rem', fontFamily: 'system-ui, sans-serif' }}>
        <h1 style={{ marginTop: 0 }}>Dashboard</h1>
        <p>Bem-vindo{user?.email ? `, ${user.email}` : ''}!</p>
        <section
          style={{
            marginTop: '2rem',
            display: 'grid',
            gap: '1.5rem',
            gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))',
          }}
        >
          {[1, 2, 3, 4].map((card) => (
            <div
              key={card}
              style={{
                background: '#fff',
                borderRadius: 16,
                padding: '1.2rem 1.25rem',
                boxShadow: '0 4px 12px -4px rgba(0,0,0,.08)',
                border: '1px solid #e4e9f2',
              }}
            >
              <h3 style={{ margin: '0 0 .5rem', fontSize: '1rem' }}>Card {card}</h3>
              <p style={{ margin: 0, fontSize: '.8rem', lineHeight: 1.4, color: '#4b5563' }}>
                Conteúdo demonstrativo para o card {card}.
              </p>
            </div>
          ))}
        </section>
        <div style={{ marginTop: '2.5rem' }}>
          <button
            onClick={handleLogout}
            style={{
              padding: '.7rem 1.2rem',
              background: '#1d3557',
              color: '#fff',
              border: 'none',
              borderRadius: 10,
              cursor: 'pointer',
              fontWeight: 600,
              letterSpacing: '.5px',
            }}
          >
            Sair
          </button>
        </div>
      </main>
    </div>
  );
};

export default DashboardPage;
